import lang from "@/views/modules/ReviewerDocuments/language/en";
import DateFormat from "@/plugins/date_format.js";
import alert from "@/views/shared/notify/Alert.vue";

//import Editor from '@tinymce/tinymce-vue';

export default {
    name: "new-reviewer-documents",

    components: {
        //   'editor': Editor,
        alert
    },
    data() {
        return {
            loading: true,
            example: {},
            lang: [],
            opp_data: {},
            app_doc: [],
            review_doc: [],
            currentUrl: '',
            allFiles: [],
            fileName: '',
            showFileName: '',
            processing: false,
            file_error:'',
            reviewStatus:'',
            statusColor:'',
            buttonClassA:'',
            buttonClassD:'',
        }
    },
    mounted() {
        this.lang = lang;
        this.getReviewerDocument();
        this.currentUrl = window.location.origin;

    },
    methods: {
        getReviewerDocument() {
            const self = this;

            let related_id = { 'related_id': self.$route.query.parent_id };

             window.currentAction = 'list';
                axios.get('api/modules/reviewerdocuments/getdocument', { params: related_id }).then(function (response) {

                self.opp_data = response.data.opp_data[0];
                
                let userData = JSON.parse(localStorage.getItem('user_prefrence'));
                if(userData.id == self.opp_data.review_by)
                {
                    
                    if(self.reviewStatus == 'Reject' || self.opp_data.review_status == 'Reject')
                    {
                        self.reviewStatus = 'Decline';
                        self.statusColor = "red";
                        self.buttonClassD = "secondary";
                        self.buttonClassA = "";
                    }else{
                        self.reviewStatus = self.opp_data.review_status;
                        self.statusColor = "green";
                        self.buttonClassD = "";
                        self.buttonClassA = "secondary";
                    }
                }
                self.app_doc = response.data.app_doc;
                self.review_doc = response.data.reviewer_doc;
            }).catch(function (e) {
                console.log(e);
            })
        },
        GetDisplayDate(date = '') {

            if (date != '') {
                const date_format = new DateFormat("dd/MM/yyyy");
                return date_format.changeDateFormat(date);
            }

        },

        changeFile(e) {
            let filelist = e.target.files;
            const fileInput = e.target;
            this.allFiles = [];
            const files = Array.from(fileInput.files);
            if (!files.length) return;
            const MAX_FILES = 5;
            if (files.length > MAX_FILES) {
                this.file_error = "You can upload a maximum of 5 files only.";
                fileInput.value = '';
                this.allFiles = [];
                return;
            }
            for (let i = 0; i < filelist.length; i++) {
                let image = e.target.files[i];
                // ----------------------------
                // FILE NAME VALIDATION
                // ----------------------------
                const MAX_FILE_NAME_LENGTH = 40;

                if (image.name.length > MAX_FILE_NAME_LENGTH) {
                    this.file_error = `File name cannot exceed ${MAX_FILE_NAME_LENGTH} characters.`;
                    this.allFiles = [];
                    return;
                }
                let fileArr = [];
                let file_type_arr = e.target.files[i].type.split("/");
                this.fileName = file_type_arr;
                this.showFileName = image.name;
                // Get the file size
                let fileSize = image.size; // in bytes
                               
                let setSize = window.app.max_file_size;
                let definedSize = 2097152;
                if(setSize[1] == 'M')
                {
                    definedSize = ((parseInt(setSize.slice(0,-1)) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }
                if(setSize[1] == 'G')
                {
                    definedSize = (((parseInt(setSize.slice(0,-1)) * 1024) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }
            
                if(fileSize < definedSize)
                {
                    this.file_error = '';
                    let reader = new FileReader();
                    reader.readAsDataURL(image);
                    reader.onload = e => {
                        //  this.file_content = e.target.result;
                        this.fileUpload = true;
                        fileArr.push(e.target.result, this.fileUpload, file_type_arr[1], image.name);
                        this.allFiles.push(fileArr);
                    };
                }else{
                    this.file_error = "The file size exceeds the maximum limit. Allowed file max size is "+ setSize;
                }
            }

        },
       
        UploadFile() {
            const self = this;
            if (self.allFiles.length > 0 && self.file_error == '') {
                self.processing = true;
                let app_id = self.$route.query.parent_id;
                axios.post('api/modules/reviewerdocuments/uploadFile', { 'app_id': app_id, 'filelist': self.allFiles, headers: { 'Content-Type': 'multipart/form-data' } }).then(function (res) {
                    if (res.data.message != '') {
                        self.allFiles = [];
                        $("#upload_document").val("");
                        self.processing = false;
                        self.$refs.notifyMsg.showAlert("Success", "Thank you for sharing your comments. The review process is complete and you can close the window");
                        self.getReviewerDocument();
                    }
                }).catch(function (error) {
                    self.loading = false;
                    let allerror = document.getElementsByClassName('error');
                    for (let i = 0; i < allerror.length; i++) {
                        allerror[i].innerHTML = '';
                    }
                    let err = localStorage.getItem('Errors');
                    let err_msg = (JSON.parse(err));
                    let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                    Object.keys(err_msg2 || {}).forEach((key) => {
                        let errorval = err_msg2[key];

                        let error_el = document.getElementById(key + "_error");
                        error_el.innerHTML = errorval
                    });
                    localStorage.removeItem('Errors');
                });
            } else {
                
                self.$refs.notifyMsg.showAlert('Error !','Please select file to upload');
            }
        },

        removeDoc(record_id) {
            const self = this;
            const deleteRecord = { 'delete_id': record_id };
            axios.post('api/modules/reviewerdocuments/remove', deleteRecord).then(function (response) {
                self.getReviewerDocument();
            }).catch(function (e) {
                console.log(e);
            })
        },
        updateStatus(status) {
            const self = this;
            axios.post('api/modules/reviewerdocuments/updatestatus', {'status':status, 'app_id':self.$route.query.parent_id}).then(function (response) {
                self.$refs.notifyMsg.showAlert('Success !','Your preference has been marked. You can close the window now');
                self.getReviewerDocument();
            }).catch(function (e) {
                console.log(e);
            })
        },
        confirmDownload(event,docObj) {
            if (!confirm("Are you sure you want to download this file?")) {
                event.preventDefault();
            } else {
                const logMessage = `Document (${docObj.name}) was successfully downloaded by the ${this.$store.state.user.name}`;
                const self = this;
                let formData = {
                    'parent_type': 'Applications',
                    'comment_from': 'ReviewerDocuments',
                    'parent_id': self.$route.query.parent_id,
                    'description':logMessage,
                    'taggedUser':[{
                        id:self.opp_data.created_by,
                        name:self.opp_data.first_name+' '+self.opp_data.last_name
                    }],
                }
                axios.post('api/modules/comments', formData).then(function (response) {
                    self.downloadFile(docObj, 'application_documents')
                }).catch(error => {
                })
            }
        },
        downloadFile(docObj, fileFor) {
            let doc_id = '';
            if(fileFor == 'application_documents'){
                doc_id = docObj.app_id;
            }

            if(fileFor == 'reviewerdocuments'){
                doc_id = docObj.id;
            }
            axios.get(`api/modules/download/${doc_id}/${fileFor}`,
                {
                    responseType: 'blob'
                }
            ).then((response) => {

                const blob = new Blob([response.data], {
                    type: response.headers['content-type']
                });

                const url = window.URL.createObjectURL(blob);

                // Read filename from Content-Disposition if available
                let filename = docObj.name;

                const disposition = response.headers['content-disposition'];

                if (disposition) {
                    const match = disposition.match(/filename="?([^"]+)"?/);
                    if (match && match[1]) {
                        filename = match[1];
                    }
                }

                const a = document.createElement('a');
                a.href = url;
                a.download = filename;

                document.body.appendChild(a);
                a.click();

                a.remove();
                window.URL.revokeObjectURL(url);
            });
        },
        addComment(status){
            const self = this;
            if(status !='')
            {
                let user = JSON.parse(localStorage.getItem('user_prefrence'));

                const logMessage = `The application review has been ${status.toLowerCase()}ed by ${user.first_name} ${user.last_name}`;
                
                let formData = {
                    'parent_type': 'Applications',
                    'comment_from': 'ReviewerDocuments',
                    'parent_id': self.$route.query.parent_id,
                    'description':logMessage,
                    'taggedUser':[{
                        id:self.opp_data.created_by,
                        name:self.opp_data.first_name+' '+self.opp_data.last_name
                    }],
                }
                axios.post('api/modules/comments', formData).then(function (response) {
                    
                    self.updateStatus(status);
                }).catch(error => {
                });
            }else{
                self.$refs.notifyMsg.showAlert('Error !', 'Oops ! Somthing went wrong, Contact Administrator');
            }
        }
    }
}